/**
 * Web entry point.
 *
 * Theme, density and language are applied to the document element before the first render,
 * exactly as the design tokens expect. Doing it after would show a flash of the wrong theme
 * — and in Arabic, a flash of the wrong direction, which is far more jarring.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './fonts.css'
import '@epmo/tokens/tokens.css'
import './index.css'
import './styles/shell-chrome.css'
import './shell.css'
import './styles/dashboard.css'
import './styles/grid-toolbar.css'
import './styles/workspace.css'
import './styles/periods.css'
import './styles/ingest.css'
import './i18n'
import { App } from './App'
import { hydratePreferences } from '@/app/preferences'

hydratePreferences()

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
